import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from '../styles/MainNavbar.module.css';

export default function MainNavbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [togglerHovered, setTogglerHovered] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') setMenuOpen(false);
        };

        let scrollY = 0;

        if (menuOpen) {
            scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.overflow = 'hidden';
        }

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            if (menuOpen) {
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.left = '';
                document.body.style.right = '';
                document.body.style.overflow = '';
                window.scrollTo(0, scrollY);
            }
        };
    }, [menuOpen]);

    const closeMenu = () => setMenuOpen(false);
    const toggleMenu = () => setMenuOpen((prev) => !prev);

    const togglerLabel = menuOpen
        ? 'close'
        : togglerHovered
            ? 'open'
            : 'menu';

    return (
        <>
            <nav
                className={`${styles.navbar} ${menuOpen ? styles.navbarPanelOpen : ''}`}
                aria-label="Main navigation"
            >
                <div className={styles.navContainer}>
                    <NavLink to="/" className={styles.brand} onClick={closeMenu}>
                        <img
                            src="/assets/meshae-studios-logo-orange.svg"
                            alt="Meshae Studios"
                            className={styles.brandLogo}
                        />
                    </NavLink>

                    <button
                        type="button"
                        aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
                        aria-expanded={menuOpen}
                        aria-controls="nav-panel"
                        className={`${styles.navToggler} ${menuOpen ? styles.navTogglerOpen : ''}`}
                        onClick={toggleMenu}
                        onMouseEnter={() => setTogglerHovered(true)}
                        onMouseLeave={() => setTogglerHovered(false)}
                    >
                        <span className={styles.togglerLabel}>{togglerLabel}</span>
                        <span className={styles.togglerIconWrap} aria-hidden="true">
                            <span className={styles.togglerLines}>
                                <span className={styles.togglerLine} />
                                <span className={styles.togglerLine} />
                            </span>
                        </span>
                    </button>
                </div>
            </nav>

            <div
                className={`${styles.backdrop} ${menuOpen ? styles.backdropVisible : ''}`}
                onClick={closeMenu}
                aria-hidden="true"
            />

            <aside
                id="nav-panel"
                className={`${styles.panel} ${menuOpen ? styles.panelOpen : ''}`}
                aria-hidden={!menuOpen}
            >
                <div className={styles.panelInner}>
                    <div className={styles.panelTop}>
                        <p className={styles.panelKicker}>menu</p>
                    </div>

                    <div className={styles.panelGrid}>
                        <div className={styles.panelRule} aria-hidden="true" />
                        <nav className={styles.panelNav} aria-label="Site navigation">
                            <NavLink
                                to="/"
                                end
                                className={({ isActive }) =>
                                    isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
                                }
                                onClick={closeMenu}
                            >
                                <span className={styles.navTitle}>Home</span>
                                <span className={styles.navMeta}>Overview / Practice</span>
                            </NavLink>
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
                                }
                                onClick={closeMenu}
                            >
                                <span className={styles.navTitle}>About</span>
                                <span className={styles.navMeta}>Background / Approach</span>
                            </NavLink>
                            <NavLink
                                to="/designlab"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
                                }
                                onClick={closeMenu}
                            >
                                <span className={styles.navTitle}>Design Lab</span>
                                <span className={styles.navMeta}>Design/ Development Portfolio </span>
                            </NavLink>
                            <NavLink
                                to="/storylab"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
                                }
                                onClick={closeMenu}
                            >
                                <span className={styles.navTitle}>Story Lab</span>
                                <span className={styles.navMeta}>Content Creator Portfolio </span>
                            </NavLink>
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
                                }
                                onClick={closeMenu}
                            >
                                <span className={styles.navTitle}>Contact</span>
                                <span className={styles.navMeta}>inquiries / new projects</span>
                            </NavLink>
                        </nav>
                    </div>

                    <div className={styles.panelFooter}>
                        <div className={styles.panelBrand}>
                            <span>meshae studios</span>
                            <span>shaping stories that move culture.</span>
                        </div>
                    </div>
                </div>
            </aside>
        </>
    );
}
